import { useState, useEffect, useCallback } from 'react';

import { useAuth } from '../contexts/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { Plus, Filter, Loader2, AlertCircle, Trash2, Download, X, RefreshCw, Archive, UserPlus, CheckSquare, Square, Tag, Upload, Building2, AlertTriangle, CheckCircle, MoreHorizontal, Columns, Eye, EyeOff, Image as ImageIcon, Info, Edit2 } from 'lucide-react';
import { StatusBadge } from '../components/badges/StatusBadge';
import { SyncStatusBadge } from '../components/badges/SyncStatusBadge';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../components/ui/tooltip';
import { Popover, PopoverContent, PopoverTrigger } from '../components/ui/popover';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Textarea } from '../components/ui/textarea';
import { Checkbox } from '../components/ui/checkbox';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../components/ui/select';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../components/ui/dialog';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../components/ui/alert-dialog';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../components/ui/dropdown-menu';
import { Switch } from '../components/ui/switch';

import { toast } from 'sonner';
import { SyncPreviewModal } from '../components/SyncPreviewModal';
import { BulkImportModal } from '../components/BulkImportModal';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
import { TrademarksTable } from '../components/tables/TrademarksTable';

export const Trademarks = () => {
  const { token, isCliente, isAdmin } = useAuth();
  const navigate = useNavigate();
  const location = useLocation(); // P0: Para leer query params
  const [trademarks, setTrademarks] = useState([]);
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);

  // ÉPICA 3.3: Filtros unificados
  const [filters, setFilters] = useState({
    search: '',       // Busca por denominación, expediente, registro
    client_id: '',
    status_id: '',
    pending_changes: false,
    no_client: false, // Marcas sin cliente asignado
  });

  // Status catalog
  const [statusCatalog, setStatusCatalog] = useState([]);

  // BUG FIX: Estado para errores de carga
  const [loadError, setLoadError] = useState(null);

  // Selection state for bulk actions
  const [selectedIds, setSelectedIds] = useState(new Set());
  const [selectAllMode, setSelectAllMode] = useState(null); // null, 'page', 'all'
  const [allFilteredIds, setAllFilteredIds] = useState([]);

  // Import modal state
  const [importModalOpen, setImportModalOpen] = useState(false);
  const [importExpediente, setImportExpediente] = useState('');
  const [importLoading, setImportLoading] = useState(false);
  const [importError, setImportError] = useState('');

  // Bulk import modal - ÉPICA 3.3: Estado mejorado
  const [bulkImportModalOpen, setBulkImportModalOpen] = useState(false);
  const [bulkExpedientes, setBulkExpedientes] = useState('');
  const [bulkImportLoading, setBulkImportLoading] = useState(false);
  const [bulkImportResults, setBulkImportResults] = useState(null);
  const [parsedExpedientes, setParsedExpedientes] = useState({ valid: [], invalid: [], total: 0 });

  // Bulk action modals
  const [assignClientModalOpen, setAssignClientModalOpen] = useState(false);

  // P0 HOTFIX: Create client from dropdown
  const [createClientModalOpen, setCreateClientModalOpen] = useState(false);
  const [newClientName, setNewClientName] = useState('');
  const [creatingClient, setCreatingClient] = useState(false);
  const [previousSelectedClientId, setPreviousSelectedClientId] = useState('');
  const [changeStatusModalOpen, setChangeStatusModalOpen] = useState(false);
  const [selectedClientId, setSelectedClientId] = useState('');
  const [selectedStatusId, setSelectedStatusId] = useState('');
  const [bulkActionLoading, setBulkActionLoading] = useState(false);

  // Archive confirmation
  const [bulkArchiveDialogOpen, setBulkArchiveDialogOpen] = useState(false);

  // Delete confirmation (bulk)
  const [bulkDeleteDialogOpen, setBulkDeleteDialogOpen] = useState(false);
  const [deleteConfirmText, setDeleteConfirmText] = useState('');
  const [deleteConfirmCheckbox, setDeleteConfirmCheckbox] = useState(false);

  // Single delete
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [trademarkToDelete, setTrademarkToDelete] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);

  // Sync state
  const [syncingId, setSyncingId] = useState(null);
  const [batchSyncing, setBatchSyncing] = useState(false);
  const [activeJob, setActiveJob] = useState(null); // For polling modal

  // Sync Preview Modal State
  const [syncModalOpen, setSyncModalOpen] = useState(false);
  const [syncPreviewData, setSyncPreviewData] = useState(null);
  const [syncingTrademarkId, setSyncingTrademarkId] = useState(null); // ID for the trademark being synced
  const [applyingSync, setApplyingSync] = useState(false);

  // Archive view toggle
  const [viewArchived, setViewArchived] = useState(false);

  // ÉPICA UI/UX Polish: Column Visibility & Persistence
  const [visibleColumns, setVisibleColumns] = useState(() => {
    const saved = localStorage.getItem('trademarks_visible_columns');
    return saved ? JSON.parse(saved) : {
      img: true,
      denominacion: true,
      expediente: true,
      registro: true,
      fecha_vigencia: true, // Default
      cliente: true,
      estatus_impi: true,
      estatus_legal: true,
      sync: true,
      actions: true
    };
  });

  // Column Visibility moved to Component internal state usually, but Page maintains state ? 
  // No, we delegated to Component. BUT we also have 'exportPDF' needing columns.
  // For Trademarks.js, we can keep using local state OR rely on component state?
  // User Requirement: "Persistencia en localStorage". The component does this.
  // The page logic for 'exportPDF' currently reads 'pdfColumns' separate state.
  // So we are safe to remove `visibleColumns` from Page logic IF we don't need it for PDF?
  // PDF columns are separate state: `pdfColumns`.
  // So we can remove `visibleColumns` state from `Trademarks.js` if we fully delegate to `TrademarksTable`.
  // HOWEVER, the Dropdown for visibility in Trademarks header (line 1414) needs to go away if the Component handles it.
  // The component has its own dropdown. 
  // I will remove `visibleColumns` from here and the UI block.

  // Quick Filters logic
  // Check localStorage for saved filters logic could be here, but "filters" state already exists.
  // We will just add quick buttons that SET existing filters.

  const applyQuickFilter = (type) => {
    switch (type) {
      case 'vigentes':
        // Find status ID for "Registrada" or similar? 
        // Better: just filter by text search OR client doesn't know IDs?
        // Safe bet: Don't guess IDs. Use "pending_changes" as valid example.
        // For status, we need to know the Catalog ID. 
        // Allow simplified "clean" filter.
        setFilters({ search: '', client_id: '', status_id: '', pending_changes: false });
        break;
      case 'problems':
        // Filter for sync errors (requires frontend filtering on list, not easy with backend params unless backend supports 'has_error')
        // Let's stick to 'pending_changes' which is supported.
        setFilters(prev => ({ ...prev, pending_changes: true }));
        break;
      case 'archived':
        setViewArchived(true);
        break;
    }
  };

  // ÉPICA Export PDF: Column Selection
  const [exportPDFModalOpen, setExportPDFModalOpen] = useState(false);
  const [pdfColumns, setPDFColumns] = useState({
    img: true,
    expediente: true,
    registro: true,
    denominacion: true,
    tipo: true,
    clases: true,
    cliente: true,
    estatus: true,
    fecha_presentacion: true,
    fecha_vigencia: true,
    notas: true
  });

  const handleTogglePdfColumn = (key) => {
    setPDFColumns(prev => ({ ...prev, [key]: !prev[key] }));
  };

  useEffect(() => {
    fetchData();

    // P0 FIX: Leer client_id de query params y aplicar filtro
    const params = new URLSearchParams(location.search);
    const clientIdParam = params.get('client_id');
    const pendingChangesParam = params.get('pending_changes');

    if (clientIdParam) {
      setFilters(prev => ({ ...prev, client_id: clientIdParam }));
    }
    if (pendingChangesParam === 'true') {
      setFilters(prev => ({ ...prev, pending_changes: true }));
    }
  }, [location.search, viewArchived]); // Add viewArchived dependency

  const fetchData = async () => {
    try {
      setLoadError(null); // Limpiar error previo
      const [trademarksRes, clientsRes, statusRes] = await Promise.all([
        axios.get(`${API}/trademarks`, {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            client_id: filters.client_id !== 'all' ? filters.client_id : undefined,
            status_id: filters.status_id !== 'all' ? filters.status_id : undefined,
            registro: filters.search || undefined, // Search also uses filters state context if inside fetchData closure
            expediente: filters.search || undefined,
            // If viewArchived is true, we want is_active=false. If false (default), is_active=true.
            is_active: viewArchived ? false : true
          }
        }),
        axios.get(`${API}/clients`, {
          headers: { Authorization: `Bearer ${token}` },
          params: { limit: 1000 }
        }),
        axios.get(`${API}/status-catalog`, {
          headers: { Authorization: `Bearer ${token}` }
        })
      ]);
      setTrademarks(trademarksRes.data);
const clientsData = clientsRes.data;
      if (clientsData && clientsData.items) {
        setClients(clientsData.items);
      } else {
        setClients(Array.isArray(clientsData) ? clientsData : []);
      }
      setStatusCatalog(statusRes.data);
      setSelectedIds(new Set());
      setSelectAllMode(null);
    } catch (error) {
      console.error('Error fetching data:', error);
      // BUG FIX: Mostrar error real en lugar de ocultar
      if (error.response && error.response.status >= 500) {
        setLoadError(`Error del servidor (${error.response.status}): ${error.response.data?.detail || 'Error al cargar marcas. Revisa los logs del backend.'}`);
      } else if (error.response && error.response.status >= 400) {
        setLoadError(`Error de autenticación (${error.response.status}): ${error.response.data?.detail || 'Sesión expirada o sin permisos.'}`);
      } else {
        setLoadError('Error de conexión: No se pudo conectar con el servidor.');
      }
    } finally {
      setLoading(false);
    }
  };

  const getClientName = (clientId) => {
    const client = clients.find(c => c.id === clientId);
    return client ? client.nombre : 'Sin asignar';
  };

  const getStatusColor = (status) => {
    if (!status) return 'status-neutral';
    const statusObj = statusCatalog.find(s => s.id === status);
    if (statusObj) {
      const name = statusObj.status_name.toLowerCase();
      if (name.includes('registrada') || name.includes('vigente')) return 'status-success';
      if (name.includes('trámite') || name.includes('examen')) return 'status-info';
      if (name.includes('pendiente') || name.includes('vencer')) return 'status-warning';
      if (name.includes('vencida') || name.includes('cancelada') || name.includes('negada')) return 'status-error';
      return 'status-neutral';
    }
    return 'status-neutral';
  };

  const isRecentlyUpdated = (tm) => {
    // Regla: Solo si ha sido sincronizada (tiene last_synced_at)
    if (!tm.last_synced_at) return false;

    const synced = new Date(tm.last_synced_at);
    const created = new Date(tm.created_at);
    const now = new Date();

    // Regla: No mostrar si acaba de ser agregada (created_at muy reciente < 24h)
    // Asumimos que "agregada" implica created_at reciente. Si fue agregada hace mucho y apenas sincronizada, sí queremos badge.
    if ((now - created) < 24 * 60 * 60 * 1000) return false;

    // Regla: Sincronizada en las últimas 24h
    return (now - synced) < 24 * 60 * 60 * 1000;
  };

  const getStatusName = (statusId) => {
    if (!statusId) return 'Sin status';
    const statusObj = statusCatalog.find(s => s.id === statusId);
    return statusObj ? statusObj.status_name : statusId;
  };

  const getImageUrl = (url) => {
    if (!url) return null;
    if (url.startsWith('/api')) {
      const baseUrl = process.env.REACT_APP_BACKEND_URL || '';
      const cleanBase = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
      return `${cleanBase}${url}`;
    }
    return url;
  };

  const handleInlineStatusUpdate = async (tmId, newStatusId) => {
    try {
      // Optimistic update
      const originalTrademarks = [...trademarks];
      setTrademarks(prev => prev.map(t =>
        t.id === tmId ? { ...t, estatus_interno: newStatusId } : t
      ));

      // Make sure we send the ID as string if it's a UUID, or whatever the backend expects
      await axios.put(`${API}/trademarks/${tmId}`, {
        estatus_interno_id: newStatusId
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      toast.success('Estatus actualizado');

      // Update local data with server response to be sure
      const updatedRes = await axios.get(`${API}/trademarks/${tmId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setTrademarks(prev => prev.map(t =>
        t.id === tmId ? updatedRes.data : t
      ));

    } catch (error) {
      console.error('Error updating status', error);
      // Detailed error message
      const status = error.response?.status;
      const detail = error.response?.data?.detail;
      const msg = detail ? `Error (${status}): ${typeof detail === 'object' ? JSON.stringify(detail) : detail}` : 'Error al actualizar estatus';
      toast.error(msg);

      await fetchData(); // Rollback on error
    }
  };

  // Helper para Estado Sync (P2 UX)
  const getSyncState = (tm) => {
    if (!tm.last_sync_at) return { status: 'never', label: 'Nunca', color: 'bg-gray-100 text-gray-800' };

    // Si tiene cambios pendientes (prioridad)
    if (tm.has_pending_changes) return { status: 'pending', label: 'Pendiente', color: 'bg-amber-100 text-amber-800' };

    // Si hubo error
    if (tm.last_sync_status === 'error') return { status: 'error', label: 'Error', color: 'bg-red-100 text-red-800' };

    // Si fue warning (ej. timeout tramites)
    if (tm.last_sync_status === 'warning') return { status: 'warning', label: 'Parcial', color: 'bg-orange-100 text-orange-800' };

    // Success / No changes
    return { status: 'success', label: 'Actualizado', color: 'bg-emerald-100 text-emerald-800' };
  };

  const formatLastSync = (dateStr) => {
    if (!dateStr) return '-';
    return new Date(dateStr).toLocaleString('es-MX', {
      day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit'
    });
  };

  // ÉPICA 3.3: Filtro unificado por búsqueda (denominación, expediente, registro)
  const filteredTrademarks = trademarks.filter(tm => {
    const search = filters.search?.toLowerCase() || '';
    if (search) {
      const matchDenom = tm.denominacion?.toLowerCase().includes(search);
      const matchExp = tm.expediente?.toLowerCase().includes(search);
      const matchReg = tm.registro?.toLowerCase().includes(search);
      if (!matchDenom && !matchExp && !matchReg) return false;
    }
    if (filters.client_id && tm.client_id !== filters.client_id) return false;
    if (filters.status_id && tm.estatus_interno !== filters.status_id) return false;
    if (filters.pending_changes && !tm.has_pending_changes) return false;
    if (filters.no_client && tm.client_id) return false; // only unassigned

    // Mostrar según el modo de vista (activas o archivadas)
    if (viewArchived) {
      return tm.is_active === false;
    } else {
      return tm.is_active !== false;
    }
  });

  // Sorting
  const [sortConfig, setSortConfig] = useState({ key: 'denominacion', direction: 'asc' });

  const requestSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const sortedTrademarks = [...filteredTrademarks].sort((a, b) => {
    if (!sortConfig.key) return 0;

    let aValue = a[sortConfig.key] || '';
    let bValue = b[sortConfig.key] || '';

    // Handle special mappings
    if (sortConfig.key === 'expediente' || sortConfig.key === 'registro') {
      const aNum = parseInt(aValue, 10);
      const bNum = parseInt(bValue, 10);
      if (!isNaN(aNum) && !isNaN(bNum)) {
        aValue = aNum;
        bValue = bNum;
      }
    }
    if (sortConfig.key === 'client_id') {
      aValue = getClientName(aValue);
      bValue = getClientName(bValue);
    }
    if (sortConfig.key === 'estatus_interno') {
      aValue = getStatusName(aValue);
      bValue = getStatusName(bValue);
    }

    if (aValue < bValue) return sortConfig.direction === 'asc' ? -1 : 1;
    if (aValue > bValue) return sortConfig.direction === 'asc' ? 1 : -1;
    return 0;
  });

  const getSortIcon = (key) => {
    if (sortConfig.key !== key) return null;
    return sortConfig.direction === 'asc' ? ' ↑' : ' ↓';
  };

  const hasActiveFilters = filters.search || filters.client_id || filters.status_id || filters.pending_changes || filters.no_client;
  const hasSelection = selectedIds.size > 0;

  // P0 FIX: Detectar si cliente filtrado no tiene marcas
  const isClientFiltered = !!filters.client_id;
  const clientHasNoTrademarks = isClientFiltered && filteredTrademarks.length === 0;

  // ÉPICA 3.3: Parse bulk expedientes (soporta newlines, comas, espacios)
  const parseExpedientes = (input) => {
    // Normalize: replace commas and multiple spaces with newlines
    const normalized = input
      .replace(/,/g, '\n')
      .replace(/\s+/g, '\n')
      .split('\n')
      .map(e => e.trim())
      .filter(e => e);

    // Validate: expedientes should be numeric or alphanumeric
    const valid = [];
    const invalid = [];

    normalized.forEach(exp => {
      // Basic validation: should contain mostly numbers
      if (/^\d+$/.test(exp) || /^[A-Z0-9\-\/]+$/i.test(exp)) {
        if (!valid.includes(exp)) valid.push(exp);
      } else {
        invalid.push(exp);
      }
    });

    return { valid, invalid, total: normalized.length };
  };

  // Update parsed expedientes when input changes
  const handleBulkInputChange = (e) => {
    const value = e.target.value;
    setBulkExpedientes(value);
    setParsedExpedientes(parseExpedientes(value));
  };

  // Selection handlers
  const toggleSelect = (id) => {
    setSelectedIds(prev => {
      const next = new Set(prev);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
    setSelectAllMode(null);
  };

  const selectAllPage = () => {
    const pageIds = filteredTrademarks.map(tm => tm.id);
    setSelectedIds(new Set(pageIds));
    setSelectAllMode('page');
  };

  const selectAllFiltered = async () => {
    try {
      const params = new URLSearchParams();
      if (filters.client_id) params.append('client_id', filters.client_id);
      if (filters.status_id) params.append('status_id', filters.status_id);

      const res = await axios.get(`${API}/trademarks/ids?${params.toString()}`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setAllFilteredIds(res.data.ids);
      setSelectedIds(new Set(res.data.ids));
      setSelectAllMode('all');

      toast.info(`${res.data.total} marcas seleccionadas (todo el resultado filtrado)`);
    } catch (error) {
      console.error('Error fetching all IDs:', error);
      toast.error('Error al seleccionar todas');
    }
  };

  const clearSelection = () => {
    setSelectedIds(new Set());
    setSelectAllMode(null);
    setAllFilteredIds([]);
  };

  const isAllPageSelected = () => {
    if (filteredTrademarks.length === 0) return false;
    return filteredTrademarks.every(tm => selectedIds.has(tm.id));
  };

  // Bulk Actions
  const executeBulkAction = async (action, payload = {}) => {
    setBulkActionLoading(true);
    try {
      const ids = Array.from(selectedIds);
      const res = await axios.post(`${API}/trademarks/bulk-action`, {
        action,
        trademark_ids: ids,
        payload
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      toast.success(`Acción completada: ${res.data.success}/${res.data.total} exitosos`);

      clearSelection();
      await fetchData();

      return res.data;
    } catch (error) {
      console.error('Error in bulk action:', error);
      toast.error(error.response?.data?.detail || 'Error en acción masiva');
    } finally {
      setBulkActionLoading(false);
    }
  };

  // P0 HOTFIX: Create client from dropdown
  const handleCreateClientFromDropdown = async () => {
    const trimmedName = newClientName.trim();
    if (!trimmedName || trimmedName.length < 2) {
      toast.error('El nombre debe tener al menos 2 caracteres');
      return;
    }

    setCreatingClient(true);
    try {
      const response = await axios.post(`${API}/clients`, {
        nombre: trimmedName
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      const newClient = response.data;

      toast.success('Cliente creado', {
        description: newClient.nombre
      });

      // Refetch clients
      const clientsResponse = await axios.get(`${API}/clients`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { limit: 1000 }
      });
      const cData = clientsResponse.data;
      if (cData && cData.items) {
        setClients(cData.items);
      } else {
        setClients(Array.isArray(cData) ? cData : []);
      }

      // Cerrar modal y seleccionar el nuevo cliente
      setCreateClientModalOpen(false);
      setNewClientName('');
      setSelectedClientId(newClient.id);

    } catch (error) {
      console.error('Error creating client:', error);
      toast.error('Error al crear cliente', {
        description: error.response?.data?.detail || 'Intente nuevamente'
      });
    } finally {
      setCreatingClient(false);
    }
  };

  const handleClientSelectChange = (value) => {
    if (value === 'create_new') {
      setPreviousSelectedClientId(selectedClientId || '');
      setCreateClientModalOpen(true);
    } else {
      setSelectedClientId(value === "none" ? "" : value);
    }
  };

  const handleCancelCreateClient = () => {
    setCreateClientModalOpen(false);
    setNewClientName('');
    // Restore previous selection
    if (previousSelectedClientId) {
      setSelectedClientId(previousSelectedClientId);
    }
  };

  const handleBulkAssignClient = async () => {
    await executeBulkAction('assign_client', {
      client_id: selectedClientId || null
    });
    setAssignClientModalOpen(false);
    setSelectedClientId('');
  };

  const handleBulkChangeStatus = async () => {
    await executeBulkAction('change_status', {
      status_id: selectedStatusId || null
    });
    setChangeStatusModalOpen(false);
    setSelectedStatusId('');
  };

  const handleBulkArchive = () => {
    setBulkArchiveDialogOpen(true);
  };

  const handleConfirmArchive = async () => {
    await executeBulkAction('archive');
    setBulkArchiveDialogOpen(false);
  };

  const handleBulkDelete = async () => {
    if (deleteConfirmText !== 'ELIMINAR' || !deleteConfirmCheckbox) {
      toast.error('Debe confirmar escribiendo ELIMINAR y marcando la casilla');
      return;
    }

    await executeBulkAction('delete');
    setBulkDeleteDialogOpen(false);
    setDeleteConfirmText('');
    setDeleteConfirmCheckbox(false);
  };

  const handleBulkRecomputeAlerts = async () => {
    await executeBulkAction('recompute_alerts');
  };

  // Single import
  const handleOpenImportModal = () => {
    setImportExpediente('');
    setImportError('');
    setImportModalOpen(true);
  };

  // Disambiguation state
  const [disambiguationModalOpen, setDisambiguationModalOpen] = useState(false);
  const [disambiguationMatches, setDisambiguationMatches] = useState([]);
  const [selectedMatch, setSelectedMatch] = useState(null);

  const handleImport = async (selectedIndex = null) => {
    const expedienteTrimmed = importExpediente.trim();

    if (!expedienteTrimmed) {
      setImportError('El número de expediente es requerido');
      return;
    }

    setImportLoading(true);
    setImportError('');

    try {
      const payload = {
        expediente: expedienteTrimmed,
        selected_match_index: selectedIndex
      };

      const response = await axios.post(
        `${API}/trademarks/ingest`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
          timeout: 60000 // P0 Fix: Wait up to 60s for IMPI scraping
        }
      );

      const result = response.data;

      // Handle Disambiguation
      if (result.mode === 'choose_one' && result.matches) {
        setDisambiguationMatches(result.matches);
        setDisambiguationModalOpen(true);
        setImportLoading(false);
        setImportModalOpen(false); // Close the initial input modal
        return;
      }

      if (result.success) {
        setImportModalOpen(false);
        setDisambiguationModalOpen(false); // Close disambiguation if open
        setImportExpediente('');
        setDisambiguationMatches([]);
        setSelectedMatch(null);

        if (result.created) {
          toast.success('Marca importada exitosamente', {
            description: `${result.trademark?.denominacion || 'Nueva marca'} ha sido agregada`
          });
        } else {
          toast.info('La marca ya existe en el sistema', {
            description: result.trademark?.denominacion
          });
        }

        await fetchData();

        const trademarkId = result.trademark_id || result.trademark?.id;
        if (trademarkId) {
          navigate(`/trademarks/${trademarkId}`);
        }
      } else {
        setImportError(result.message || result.error || 'Error al importar la marca');
        // If error happened during disambiguation selection, show it there or re-open import?
        // Let's keep the import modal open if it was a direct error, or toast if it was async
        if (selectedIndex !== null) {
          toast.error(result.message || 'Error al importar selección');
        }
      }
    } catch (error) {
      console.error('Error importing trademark:', error);
      // P0: User requested explicit blame on IMPI server for these errors
      let errorMsg = error.response?.data?.detail;

      if (!errorMsg) {
        if (error.code === 'ECONNABORTED') {
          errorMsg = 'Tiempo de espera agotado (60s). El servidor del IMPI está lento.';
        } else if (error.message) {
          errorMsg = `Error: ${error.message}`;
        } else {
          errorMsg = 'Error desconocid al conectar con el servidor.';
        }
      }

      setImportError(errorMsg);
    } finally {
      if (selectedIndex === null && !disambiguationModalOpen) {
        // Only stop loading if we are NOT switching to disambiguation modal
        // Logic is tricky here because setState is async.
        // But effectively, if we setDisambiguationModalOpen(true) above, we define loading state there.
      }
      setImportLoading(false);
    }
  };

  const handleDisambiguationSelect = (match) => {
    setSelectedMatch(match);
    // Auto-submit or require button click? Let's require button click for safety, or auto?
    // "Select" button in row usually implies action.
    // Let's call handleImport with the index.
    handleImport(match.index);
  };

  // Bulk import - ÉPICA 3.3: Usa expedientes parseados y validados
  const handleBulkImport = async () => {
    if (parsedExpedientes.valid.length === 0) {
      toast.error('No hay expedientes válidos para importar');
      return;
    }

    setBulkImportLoading(true);
    setBulkImportResults(null);

    try {
      const res = await axios.post(`${API}/trademarks/ingest/bulk`, {
        expedientes: parsedExpedientes.valid
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setBulkImportResults(res.data);

      toast.success(`Importación completada: ${res.data.created} nuevas, ${res.data.already_exists} existentes, ${res.data.errors} errores`);

      await fetchData();

      // If there are created IDs, offer to select them
      if (res.data.created_ids?.length > 0) {
        setSelectedIds(new Set(res.data.created_ids));
        setSelectAllMode(null);
      }
    } catch (error) {
      console.error('Error in bulk import:', error);
      toast.error(error.response?.data?.detail || 'Error en importación masiva');
    } finally {
      setBulkImportLoading(false);
    }
  };

  // Single delete - ÉPICA 3.4: Requiere doble confirmación
  const handleDeleteClick = (e, trademark) => {
    e.stopPropagation();
    setTrademarkToDelete(trademark);
    setDeleteConfirmText('');
    setDeleteConfirmCheckbox(false);
    setDeleteDialogOpen(true);
  };

  const handleDeleteConfirm = async () => {
    if (!trademarkToDelete) return;
    if (deleteConfirmText !== 'ELIMINAR' || !deleteConfirmCheckbox) {
      toast.error('Debe confirmar escribiendo ELIMINAR y marcando la casilla');
      return;
    }

    setDeleteLoading(true);
    try {
      await axios.delete(`${API}/trademarks/${trademarkToDelete.id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      toast.success('Marca eliminada exitosamente', {
        description: trademarkToDelete.denominacion || trademarkToDelete.expediente
      });

      await fetchData();
    } catch (error) {
      console.error('Error deleting trademark:', error);
      toast.error(error.response?.data?.detail || 'Error al eliminar la marca');
    } finally {
      setDeleteLoading(false);
      setDeleteDialogOpen(false);
      setTrademarkToDelete(null);
      setDeleteConfirmText('');
      setDeleteConfirmCheckbox(false);
    }
  };

  // Inline client assignment from table
  const handleAssignClient = async (tmId, newClientId) => {
    // Optimistic update
    setTrademarks(prev => prev.map(t =>
      t.id === tmId ? { ...t, client_id: newClientId } : t
    ));
    try {
      await axios.put(`${API}/trademarks/${tmId}`, {
        client_id: newClientId
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const clientName = newClientId ? (clients.find(c => c.id === newClientId)?.nombre || newClientId) : 'ninguno';
      toast.success(newClientId ? `Cliente asignado: ${clientName}` : 'Cliente removido');
    } catch (error) {
      console.error('Error assigning client:', error);
      toast.error('Error al asignar cliente');
      fetchData(); // Revert
    }
  };

  // Filters - ÉPICA 3.3: Unificados
  const clearFilter = (filterKey) => {
    setFilters(prev => ({ ...prev, [filterKey]: '' }));
  };

  const clearAllFilters = () => {
    setFilters({ search: '', client_id: '', status_id: '', pending_changes: false, no_client: false });
  };

  // Sync
  // Sync V2: Preview & Changesets
  const handleSyncTrademark = async (e, trademark) => {
    e.stopPropagation();
    setSyncingId(trademark.id);

    try {
      // Usar endpoint V2 (Preview)
      const response = await axios.post(`${API}/trademarks/${trademark.id}/sync/preview`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });

      const data = response.data;

      if (data.success) {
        if (data.summary.requires_approval > 0 || data.summary.added > 0 || data.summary.filled > 0) {
          // Si hay cambios (críticos o automáticos), abrir modal
          setSyncPreviewData(data);
          setSyncingTrademarkId(trademark.id);
          setSyncModalOpen(true);
        } else {
          toast.success('Sincronizado: Sin cambios detectados');
          // Actualizar timestamp de todas formas
          await fetchData();
        }
      } else {
        toast.error(data.message || 'Error en sincronización');
      }
    } catch (error) {
      console.error('Sync error:', error);
      toast.error(error.response?.data?.detail || 'Error al sincronizar');
    } finally {
      setSyncingId(null);
    }
  };

  const handleApplySync = async (acceptedIds, rejectedIds) => {
    if (!syncingTrademarkId) return;

    setApplyingSync(true);
    try {
      await axios.post(`${API}/trademarks/${syncingTrademarkId}/sync/apply`, {
        changeset_id: syncPreviewData.changeset_id,
        accepted_item_ids: acceptedIds,
        rejected_item_ids: rejectedIds
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      toast.success('Cambios aplicados exitosamente');
      setSyncModalOpen(false);
      setSyncPreviewData(null);
      setSyncingTrademarkId(null);
      await fetchData();
    } catch (error) {
      console.error('Error applying sync:', error);
      toast.error(error.response?.data?.detail || 'Error al aplicar cambios');
    } finally {
      setApplyingSync(false);
    }
  };

  const handleSyncBatch = async () => {
    setBatchSyncing(true);
    try {
      const idsToSync = selectedIds.size > 0
        ? Array.from(selectedIds)
        : filteredTrademarks.map(tm => tm.id);

      if (idsToSync.length === 0) {
        toast.warning("No hay marcas seleccionadas para sincronizar");
        setBatchSyncing(false);
        return;
      }

      const res = await axios.post(`${API}/sync/trademarks`, {
        trademark_ids: idsToSync
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      // Start polling
      if (res.data.job_id) {
        setBatchSyncing(true); // Keep loading state if needed, or rely on modal
        pollSyncJob(res.data.job_id);
      } else {
        toast.success(`Sincronización iniciada`);
      }
    } catch (error) {
      toast.error('Error en sincronización masiva');
      setBatchSyncing(false);
    }
  };

  const pollSyncJob = async (jobId) => {
    const checkJob = async () => {
      try {
        const res = await axios.get(`${API}/sync/current-job`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const job = res.data;

        // If the returned job matches our ID (or is the active one)
        if (job && job.id === jobId) {
          setActiveJob(job);

          if (job.status === 'completed' || job.status === 'failed' || job.status === 'completed_with_errors') {
            setBatchSyncing(false);
            toast.success('Sincronización finalizada');
            // fetchData will be called when closing modal
            return;
          }
        } else if (job.status === 'idle') {
          // Job finished and disappeared? Or never started?
          // Check if we have a previous activeJob state that was completed?
          // For now, if idle and we were polling, assume finished or lost.
          setBatchSyncing(false);
          return;
        }

        setTimeout(checkJob, 2000);
      } catch (err) {
        console.error("Error polling job", err);
        setBatchSyncing(false);
      }
    };
    checkJob();
  };

  // P0 FIX: Export - Maneja CSV (legacy), Excel, PDF con serialización defensiva
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = async (format = 'csv', payloadOverride = null) => {
    if (isExporting) return; // Prevenir clicks múltiples

    setIsExporting(true);
    try {
      const count = selectedIds.size > 0 ? selectedIds.size : filteredTrademarks.length;
      const formatLabel = format === 'excel' ? 'Excel' : format === 'pdf' ? 'PDF' : 'CSV';

      toast.info(selectedIds.size > 0
        ? `Exportando ${count} marca(s) seleccionada(s) a ${formatLabel}...`
        : `Exportando ${count} marca(s) a ${formatLabel}...`
      );

      let endpoint, mimeType, extension;

      if (format === 'excel') {
        endpoint = `${API}/trademarks/export/excel`;
        mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        extension = 'xlsx';
        extension = 'xlsx';
      } else if (format === 'pdf') {
        // P0: Intercept PDF to show column selector
        if (!payloadOverride) { // If payloadOverride is present, it's the confirmed call
          setExportPDFModalOpen(true);
          setIsExporting(false);
          return;
        }
        endpoint = `${API}/trademarks/export/pdf`;
        mimeType = 'application/pdf';
        extension = 'pdf';
      } else {
        // CSV legacy
        endpoint = `${API}/trademarks/export`;
        mimeType = 'text/csv;charset=utf-8;';
        extension = 'csv';
      }

      // P0: Construir body correcto - array de IDs si hay selección, null si no
      let body = null;
      if (selectedIds.size > 0) {
        body = Array.from(selectedIds);
      }

      // Construir query params para filtros (solo si no hay selección)
      const params = new URLSearchParams();
      if (selectedIds.size === 0) {
        if (filters.client_id) params.append('client_id', filters.client_id);
        if (filters.status_id) params.append('status_id', filters.status_id);
      }

      const queryString = params.toString() ? `?${params.toString()}` : '';

      // P0: Merge payloadOverride (columns) with body
      if (payloadOverride && typeof payloadOverride === 'object') {
        body = { ...(body && Array.isArray(body) ? { trademark_ids: body } : {}), ...payloadOverride };
        // If body was null but we have override, we need to construct object. 
        // But axios sends body as second arg. If list, backend expects list. If object, backend expects object.
        // Endpoint PDF was modified to expect trademark_ids AND columns in body.
        // Wait, original endpoint likely expects just list of IDs if body is list. check endpoints_core.py changes.
        // We updated endpoint to accept trademark_ids: List[str] = Body(None), columns: List[str] = Body(None).
        // So for PDF, body MUST be a JSON object, not a list of IDs directly if we want to send columns too.
        // Correcting logic:
        if (format === 'pdf') {
          // For PDF, body is alway JSON object { trademark_ids: [...], columns: [...] }
          const ids = selectedIds.size > 0 ? Array.from(selectedIds) : null;
          body = { trademark_ids: ids, ...payloadOverride };
        }
      }

      const response = await axios.post(`${endpoint}${queryString}`, body, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        responseType: 'blob'
      });

      // P0: Verificar que la respuesta es un blob válido
      if (!response.data || response.data.size === 0) {
        throw new Error('El archivo generado está vacío');
      }

      // P0: Detección fuerte de errores (Sniffing)
      // A veces el servidor devuelve JSON con error 500 pero el content-type se pierde o blob lo mascara
      const textStart = await response.data.slice(0, 50).text();
      if (textStart.trim().startsWith('{')) {
        const fullText = await response.data.text();
        try {
          const json = JSON.parse(fullText);
          throw new Error(json.detail || 'Error desconocido del servidor (JSON)');
        } catch (e) {
          // Si parsea OK, lanza el error.
          if (e.message !== 'Unexpected token' && !e.message.includes('JSON')) throw e;
        }
      }

      // P0 FIX: Intentar obtener el nombre real del archivo desde el header
      let filename = `marcas_export_${new Date().toISOString().split('T')[0]}.${extension}`;

      const contentDisposition = response.headers['content-disposition'];
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1].replace(/['"]/g, '');
        }
      }

      // Asegurar que el filename tenga la extensión correcta
      if (!filename.endsWith(`.${extension}`)) {
        filename = `${filename}.${extension}`;
      }

      // Crear link de descarga con método más robusto
      const blob = new Blob([response.data], { type: mimeType });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename); // Usar setAttribute para mayor compatibilidad
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();

      // Cleanup
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);

      toast.success(`Exportación a ${formatLabel} completada`);
    } catch (error) {
      console.error('Error exporting:', error);

      // P0: Manejo específico de errores
      let errorMessage = 'Error al generar el archivo. Revisa los datos de las marcas seleccionadas.';

      if (error.response?.status === 404) {
        errorMessage = 'No hay marcas para exportar';
      } else if (error.response?.status === 500) {
        errorMessage = 'Error en el servidor al generar el archivo';
      } else if (error.message) {
        errorMessage = error.message;
      }

      toast.error(errorMessage, {
        duration: 5000,
        description: 'Si el problema persiste, contacta al administrador'
      });
    } finally {
      setIsExporting(false);
    }
  };

  // ÉPICA 3.3: Filter chips unificados
  const getActiveFilterChips = () => {
    const chips = [];
    if (filters.search) chips.push({ key: 'search', label: `Búsqueda: ${filters.search}` });
    if (filters.client_id) {
      const client = clients.find(c => c.id === filters.client_id);
      chips.push({ key: 'client_id', label: `Cliente: ${client?.nombre || filters.client_id}` });
    }
    if (filters.status_id) {
      const status = statusCatalog.find(s => s.id === filters.status_id);
      chips.push({ key: 'status_id', label: `Estatus: ${status?.status_name || filters.status_id}` });
    }
    if (filters.pending_changes) {
      chips.push({ key: 'pending_changes', label: 'Cambios pendientes' });
    }
    return chips;
  };

  return (
    <>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
          <div className="flex-1">
            <h2 className="text-2xl font-semibold text-gray-900">Marcas</h2>
            <p className="text-sm text-gray-500 mt-1">Portafolio completo de marcas registradas</p>
          </div>
          <div className="flex flex-wrap items-center gap-2 sm:gap-3">
            {/* Bulk import button */}
            {!isCliente() && (
              <Button
                variant="outline"
                onClick={() => setBulkImportModalOpen(true)}
                className="border-gray-300 h-9 sm:h-10 text-xs sm:text-sm"
                data-testid="bulk-import-btn"
              >
                <Upload className="mr-1 sm:mr-2 h-3.5 w-3.5 sm:h-4 sm:w-4" />
                <span className="inline">Importar en bloque</span>
              </Button>
            )}
            {/* Sync batch */}
            {!isCliente() && hasActiveFilters && (
              <Button
                variant="outline"
                onClick={handleSyncBatch}
                disabled={batchSyncing}
                className="border-gray-300 h-9 sm:h-10 text-xs sm:text-sm"
                data-testid="sync-batch-btn"
              >
                {batchSyncing ? (
                  <>
                    <Loader2 className="mr-1 sm:mr-2 h-3.5 w-3.5 sm:h-4 sm:w-4 animate-spin" />
                    Sincronizando...
                  </>
                ) : (
                  <>
                    <RefreshCw className="mr-1 sm:mr-2 h-3.5 w-3.5 sm:h-4 sm:w-4" />
                    Sincronizar ({filteredTrademarks.length})
                  </>
                )}
              </Button>
            )}
            {/* Export */}
            {(filteredTrademarks.length > 0 || selectedIds.size > 0) && (
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <Button
                    variant="outline"
                    className="border-gray-300 h-9 sm:h-10 text-xs sm:text-sm"
                    data-testid="export-btn"
                    disabled={isExporting}
                  >
                    {isExporting ? (
                      <>
                        <Loader2 className="mr-1 sm:mr-2 h-3.5 w-3.5 sm:h-4 sm:w-4 animate-spin" />
                        Exportando...
                      </>
                    ) : (
                      <>
                        <Download className="mr-1 sm:mr-2 h-3.5 w-3.5 sm:h-4 sm:w-4" />
                        {selectedIds.size > 0
                          ? `Exportar (${selectedIds.size})`
                          : `Exportar (${filteredTrademarks.length})`
                        }
                      </>
                    )}
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end">
                  <DropdownMenuItem onClick={() => handleExport('excel')} disabled={isExporting}>
                    <Download className="mr-2 h-4 w-4" />
                    Excel (.xlsx)
                  </DropdownMenuItem>
                  <DropdownMenuItem onClick={() => handleExport('pdf')} disabled={isExporting}>
                    <Download className="mr-2 h-4 w-4" />
                    PDF
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
            )}
            {/* Nueva Marca */}
            {!isCliente() && (
              <Button
                onClick={handleOpenImportModal}
                className="bg-gray-900 hover:bg-gray-800 text-white h-9 sm:h-10 text-xs sm:text-sm"
                data-testid="new-trademark-button"
              >
                <Plus className="mr-1 sm:mr-2 h-3.5 w-3.5 sm:h-4 sm:w-4" />
                Nueva Marca
              </Button>
            )}
          </div>
        </div>

        {/* Bulk Actions Bar */}
        {!isCliente() && hasSelection && (
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 flex flex-col md:flex-row md:items-center justify-between gap-4">
            <div className="flex items-center gap-4">
              <span className="text-sm font-medium text-blue-700">
                {selectedIds.size} marca(s) seleccionada(s)
                {selectAllMode === 'all' && ' (todo el resultado filtrado)'}
              </span>
              <Button variant="ghost" size="sm" onClick={clearSelection} className="text-blue-600">
                <X className="h-4 w-4 mr-1" /> Limpiar
              </Button>
            </div>
            <div className="flex flex-wrap items-center gap-2">
              {/* Assign Client - HIGHEST PRIORITY */}
              <Button
                variant="outline"
                size="sm"
                onClick={() => setAssignClientModalOpen(true)}
                disabled={bulkActionLoading}
                className="border-blue-300 text-blue-700 hover:bg-blue-100"
                data-testid="bulk-assign-client-btn"
              >
                <UserPlus className="h-4 w-4 mr-1" />
                Asignar cliente
              </Button>
              {/* Change Status */}
              <Button
                variant="outline"
                size="sm"
                onClick={() => setChangeStatusModalOpen(true)}
                disabled={bulkActionLoading}
                className="border-gray-300"
                data-testid="bulk-change-status-btn"
              >
                <Tag className="h-4 w-4 mr-1" />
                Cambiar estatus
              </Button>
              {/* Sync Batch */}
              <Button
                variant="outline"
                size="sm"
                onClick={handleSyncBatch}
                disabled={batchSyncing}
                className="border-gray-300"
              >
                <RefreshCw className={`h-4 w-4 mr-1 ${batchSyncing ? 'animate-spin' : ''}`} />
                Sincronizar
              </Button>
              {/* Recompute Alerts */}
              <Button
                variant="outline"
                size="sm"
                onClick={handleBulkRecomputeAlerts}
                disabled={bulkActionLoading}
                className="border-gray-300"
                data-testid="bulk-recompute-btn"
              >
                <RefreshCw className="h-4 w-4 mr-1" />
                Recalcular alertas
              </Button>
              {/* Archive */}
              <Button
                variant="outline"
                size="sm"
                onClick={handleBulkArchive}
                disabled={bulkActionLoading}
                className="border-indigo-300 text-indigo-700 hover:bg-indigo-50"
                data-testid="bulk-archive-btn"
              >
                <Archive className="h-4 w-4 mr-1" />
                Archivar
              </Button>
              {/* Delete - ADMIN ONLY */}
              {isAdmin() && (
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => setBulkDeleteDialogOpen(true)}
                  disabled={bulkActionLoading}
                  className="border-red-300 text-red-700 hover:bg-red-50"
                  data-testid="bulk-delete-btn"
                >
                  <Trash2 className="h-4 w-4 mr-1" />
                  Eliminar
                </Button>
              )}
            </div>
          </div>
        )}

        {/* Quick Filters & Columns Bar */}
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 bg-white p-4 rounded-lg border border-gray-200">
          {/* Quick Chips */}
          <div className="flex items-center gap-2 overflow-x-auto pb-2 md:pb-0 scrollbar-hide">
            <Button
              variant={filters.pending_changes ? "secondary" : "ghost"}
              size="sm"
              onClick={() => setFilters(prev => ({ ...prev, pending_changes: !prev.pending_changes }))}
              className={`rounded-full border ${filters.pending_changes ? 'border-amber-200 bg-amber-50 text-amber-800' : 'border-gray-200 text-gray-600'}`}
            >
              <AlertTriangle className="h-3 w-3 mr-1.5" />
              Cambios pendientes
            </Button>
            <Button
              variant={viewArchived ? "secondary" : "ghost"}
              size="sm"
              onClick={() => setViewArchived(!viewArchived)}
              className={`rounded-full border ${viewArchived ? 'border-indigo-200 bg-indigo-50 text-indigo-800' : 'border-gray-200 text-gray-600'}`}
            >
              <Archive className="h-3 w-3 mr-1.5" />
              Archivadas
            </Button>
            <Button
              variant={filters.no_client ? "secondary" : "ghost"}
              size="sm"
              onClick={() => setFilters(prev => ({ ...prev, no_client: !prev.no_client, client_id: '' }))}
              className={`rounded-full border ${filters.no_client ? 'border-orange-200 bg-orange-50 text-orange-800' : 'border-gray-200 text-gray-600'}`}
            >
              <Building2 className="h-3 w-3 mr-1.5" />
              Sin cliente
            </Button>
            {hasActiveFilters && (
              <Button
                variant="ghost"
                size="sm"
                onClick={clearAllFilters}
                className="text-gray-500 hover:text-red-600 rounded-full"
              >
                <X className="h-3 w-3 mr-1" />
                Limpiar
              </Button>
            )}
          </div>

          <div className="flex items-center gap-2">
            {/* Search */}
            <div className="relative">
              <Filter className="absolute left-2.5 top-2.5 h-4 w-4 text-gray-400" />
              <Input
                placeholder="Buscar..."
                value={filters.search}
                onChange={(e) => setFilters({ ...filters, search: e.target.value })}
                className="h-9 pl-9 w-40 md:w-60 bg-gray-50 focus:bg-white transition-colors"
              />
            </div>

            {/* Client Filter Compact */}
            <Select value={filters.client_id || "all"} onValueChange={(value) => setFilters({ ...filters, client_id: value === "all" ? "" : value, no_client: false })}>
              <SelectTrigger className="h-9 w-[140px] md:w-[180px]">
                <SelectValue placeholder="Cliente" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">Todos</SelectItem>
                {clients.map(client => (
                  <SelectItem key={client.id} value={client.id}>{client.nombre}</SelectItem>
                ))}
              </SelectContent>
            </Select>

            {/* Columns Toggle - moved here from inside table */}
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="outline" size="sm" className="h-9 gap-1.5 border-dashed">
                  <Columns className="h-3.5 w-3.5" />
                  <span className="hidden md:inline text-xs">Columnas</span>
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-48">
                {[
                  { key: 'img', label: 'Imagen' },
                  { key: 'denominacion', label: 'Denominación' },
                  { key: 'expediente', label: 'Expediente' },
                  { key: 'registro', label: 'Registro' },
                  { key: 'fecha_vigencia', label: 'Vigencia' },
                  { key: 'cliente', label: 'Cliente' },
                  { key: 'estatus_impi', label: 'Estatus IMPI' },
                  { key: 'estatus_legal', label: 'Estatus Legal' },
                  { key: 'sync', label: 'Actualización IMPI' },
                ].map(col => (
                  <DropdownMenuItem
                    key={col.key}
                    onClick={() => {
                      const saved = localStorage.getItem('trademarks_visible_columns');
                      const current = saved ? JSON.parse(saved) : {};
                      const updated = { ...current, [col.key]: !current[col.key] };
                      localStorage.setItem('trademarks_visible_columns', JSON.stringify(updated));
                      // Force re-render by triggering a storage event
                      window.dispatchEvent(new Event('storage'));
                    }}
                  >
                    <Columns className="h-3.5 w-3.5 mr-2 opacity-50" />
                    {col.label}
                  </DropdownMenuItem>
                ))}
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        </div>

        {/* Table */}
        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
          {loading ? (
            <div className="p-12 text-center">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mx-auto"></div>
            </div>
          ) : loadError ? (
            /* BUG FIX: Mostrar error real en lugar de "No se encontraron marcas" */
            <div className="p-12 text-center">
              <div className="text-red-500 mb-4">
                <svg className="mx-auto h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                </svg>
              </div>
              <p className="text-red-600 font-medium mb-2">Error al cargar marcas</p>
              <p className="text-gray-500 text-sm mb-4">{loadError}</p>
              <Button variant="outline" onClick={() => { setLoading(true); setLoadError(null); fetchData(); }}>
                Reintentar
              </Button>
            </div>
          ) : clientHasNoTrademarks ? (
            /* P0 FIX: Mensaje específico cuando cliente filtrado no tiene marcas */
            <div className="p-12 text-center">
              <Building2 className="h-12 w-12 text-gray-300 mx-auto mb-4" />
              <p className="text-gray-600 font-medium mb-2">Este cliente aún no tiene marcas asignadas</p>
              <p className="text-sm text-gray-500 mb-4">
                {clients.find(c => c.id === filters.client_id)?.nombre || 'El cliente seleccionado'} no tiene marcas registradas en el sistema
              </p>
              <div className="flex gap-2 justify-center">
                <Button variant="outline" onClick={() => setFilters(prev => ({ ...prev, client_id: '' }))}>
                  Ver todas las marcas
                </Button>
                {!isCliente() && (
                  <Button onClick={() => setImportModalOpen(true)} className="bg-gray-900 hover:bg-gray-800">
                    <Plus className="mr-2 h-4 w-4" />
                    Importar marca
                  </Button>
                )}
              </div>
            </div>
          ) : (
            <TrademarksTable
              trademarks={sortedTrademarks}
              loading={loading}
              selectedIds={selectedIds}
              onSelectionChange={toggleSelect}
              onSelectAll={(mode) => {
                if (mode === 'page') selectAllPage();
                else if (mode === 'filtered') selectAllFiltered();
                else if (mode === true) selectAllPage(); // Simple check
                else if (mode === false) clearSelection();
                else selectAllPage();
              }}
              selectAllMode={selectAllMode}
              onClearSelection={clearSelection}
              sortConfig={sortConfig}
              onSort={requestSort}
              storageKey="trademarks_visible_columns"
              showClientColumn={true}
              showFolderColumn={false}
              isCliente={isCliente()}
              isAdmin={isAdmin()}
              statusCatalog={statusCatalog}
              onUpdateFallbackName={async (tmId, newVal) => {
                try {
                  const originalTrademarks = [...trademarks];
                  setTrademarks(prev => prev.map(t =>
                    t.id === tmId ? { ...t, fallback_name: newVal } : t
                  ));
                  await axios.put(`${API}/trademarks/${tmId}`, {
                    fallback_name: newVal
                  }, {
                    headers: { Authorization: `Bearer ${token}` }
                  });
                  toast.success('Nombre de referencia actualizado');
                } catch (error) {
                  console.error('Error updating fallback name', error);
                  toast.error('Error al actualizar nombre de referencia');
                  fetchData();
                }
              }}
              onUpdateStatus={handleInlineStatusUpdate}
              onAssignClient={!isCliente() ? handleAssignClient : undefined}
              clients={clients}
              getClientName={(id) => {
                const c = clients.find(cl => cl.id === id);
                return c ? c.nombre : 'Sin asignar';
              }}
              onRowClick={(tm) => navigate(`/trademarks/${tm.id}`)}
              actionsRenderer={(tm) => ( // Custom actions logic if we want to override or stick to default? 
                // Use default logic inside Component OR pass exact menu items.
                // The component has "Ver detalle". We need "Sync" and "Delete".
                // Let's pass the menu items as Fragments.

                <>
                  <DropdownMenuItem onClick={() => navigate(`/trademarks/${tm.id}`)}>
                    <Eye className="h-4 w-4 mr-2" />
                    Ver detalle
                  </DropdownMenuItem>
                  <DropdownMenuItem onClick={(e) => handleSyncTrademark(e, tm)} disabled={syncingId === tm.id}>
                    <RefreshCw className={`h-4 w-4 mr-2 ${syncingId === tm.id ? 'animate-spin' : ''}`} />
                    Sincronizar ahora
                  </DropdownMenuItem>
                  {isAdmin() && (
                    <>
                      <DropdownMenuSeparator />
                      <DropdownMenuItem onClick={(e) => handleDeleteClick(e, tm)} className="text-red-600 hover:text-red-700 hover:bg-red-50">
                        <Trash2 className="h-4 w-4 mr-2" />
                        Eliminar
                      </DropdownMenuItem>
                    </>
                  )}
                </>
              )}
            />
          )}
        </div>

        {/* Summary */}
        <div className="text-sm text-gray-500">
          Mostrando {filteredTrademarks.length} de {trademarks.length} marcas
        </div>
      </div>

      {/* Search Progress/Summary Modal */}
      <Dialog open={!!activeJob} onOpenChange={(open) => { if (!open && activeJob?.status !== 'running') setActiveJob(null); }}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle>
              {activeJob?.status === 'completed' ? 'Sincronización Completada' :
                activeJob?.status === 'running' || activeJob?.status === 'pending' ? 'Sincronizando...' :
                  'Estado de Sincronización'}
            </DialogTitle>
            <DialogDescription>
              {activeJob?.status === 'running' || activeJob?.status === 'pending'
                ? 'Por favor espere mientras se actualizan las marcas desde el IMPI.'
                : 'El proceso ha finalizado.'}
            </DialogDescription>
          </DialogHeader>

          <div className="py-4 space-y-4">
            {/* Progress Bar */}
            <div className="space-y-1">
              <div className="flex justify-between text-xs text-gray-500">
                <span>Progreso</span>
                <span>{activeJob?.progress?.percent || 0}% ({activeJob?.progress?.current || 0}/{activeJob?.progress?.total || '?'})</span>
              </div>
              <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
                <div
                  className={`h-full transition-all duration-500 ${activeJob?.status === 'completed' ? 'bg-green-500' : 'bg-blue-600'}`}
                  style={{ width: `${activeJob?.progress?.percent || 0}%` }}
                ></div>
              </div>
            </div>

            {/* Stats (only when done or if available) */}
            {activeJob && (
              <div className="grid grid-cols-2 gap-4 pt-2">
                <div className="bg-green-50 p-3 rounded-lg text-center">
                  <div className="text-2xl font-bold text-green-700">{activeJob.result ? (activeJob.result.success || 0) : '-'}</div>
                  <div className="text-xs text-green-800">Actualizadas</div>
                </div>
                <div className="bg-red-50 p-3 rounded-lg text-center">
                  <div className="text-2xl font-bold text-red-700">{activeJob.result ? (activeJob.result.errors || 0) : '-'}</div>
                  <div className="text-xs text-red-800">Errores</div>
                </div>
              </div>
            )}

            {activeJob?.error && (
              <div className="bg-red-50 text-red-700 p-3 rounded text-sm">
                {activeJob.error}
              </div>
            )}
          </div>

          <DialogFooter>
            <Button
              onClick={() => { setActiveJob(null); fetchData(); }}
              disabled={activeJob?.status === 'running' || activeJob?.status === 'pending'}
            >
              Cerrar
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Single Import Modal */}
      <Dialog open={importModalOpen} onOpenChange={setImportModalOpen}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle>Importar marca desde IMPI</DialogTitle>
            <DialogDescription>
              Ingresa el número de expediente para importar los datos de la marca.
            </DialogDescription>
          </DialogHeader>

          <div className="space-y-4 py-4">
            <Input
              placeholder="Ej. 1128898"
              value={importExpediente}
              onChange={(e) => { setImportExpediente(e.target.value); setImportError(''); }}
              onKeyDown={(e) => e.key === 'Enter' && !importLoading && handleImport()}
              disabled={importLoading}
              autoFocus
              data-testid="import-expediente-input"
            />

            {importError && (
              <div className="flex items-start gap-2 text-sm text-red-600 bg-red-50 p-3 rounded-md">
                <AlertCircle className="h-4 w-4 mt-0.5 flex-shrink-0" />
                <span>{importError}</span>
              </div>
            )}
          </div>

          <DialogFooter className="gap-2">
            <Button variant="outline" onClick={() => setImportModalOpen(false)} disabled={importLoading}>
              Cancelar
            </Button>
            <Button onClick={() => handleImport()} disabled={importLoading || !importExpediente.trim()} className="bg-gray-900 hover:bg-gray-800" data-testid="import-submit-button">
              {importLoading ? (<><Loader2 className="mr-2 h-4 w-4 animate-spin" />Importando...</>) : 'Importar'}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Assign Client Modal */}
      {/* P0 HOTFIX: Assign Client Modal with "+ Nuevo cliente..." option */}
      <Dialog open={assignClientModalOpen} onOpenChange={setAssignClientModalOpen}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle>Asignar cliente</DialogTitle>
            <DialogDescription>
              Selecciona un cliente para asignar a las {selectedIds.size} marca(s) seleccionada(s).
              Selecciona &ldquo;Quitar cliente&rdquo; para desvincular.
            </DialogDescription>
          </DialogHeader>

          <div className="py-4">
            <Select value={selectedClientId || "none"} onValueChange={handleClientSelectChange}>
              <SelectTrigger>
                <SelectValue placeholder="Seleccionar cliente" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="none">— Quitar cliente —</SelectItem>
                {clients.filter(c => c.activo).map(client => (
                  <SelectItem key={client.id} value={client.id}>{client.nombre}</SelectItem>
                ))}
                <SelectItem value="create_new" className="text-blue-600 font-medium">+ Nuevo cliente...</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <DialogFooter className="gap-2">
            <Button variant="outline" onClick={() => setAssignClientModalOpen(false)} disabled={bulkActionLoading}>
              Cancelar
            </Button>
            <Button onClick={handleBulkAssignClient} disabled={bulkActionLoading || !selectedClientId} className="bg-blue-600 hover:bg-blue-700" data-testid="confirm-assign-client">
              {bulkActionLoading ? (<><Loader2 className="mr-2 h-4 w-4 animate-spin" /></>) : null}
              {selectedClientId ? 'Asignar' : 'Quitar cliente'}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* P0 HOTFIX: Create Client Modal */}
      <Dialog open={createClientModalOpen} onOpenChange={setCreateClientModalOpen}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle>Crear cliente</DialogTitle>
            <DialogDescription>
              Ingresa el nombre del nuevo cliente
            </DialogDescription>
          </DialogHeader>

          <div className="py-4">
            <Label htmlFor="newClientName">Nombre del cliente</Label>
            <Input
              id="newClientName"
              value={newClientName}
              onChange={(e) => setNewClientName(e.target.value)}
              placeholder="Nombre del cliente"
              onKeyDown={(e) => e.key === 'Enter' && !creatingClient && handleCreateClientFromDropdown()}
              autoFocus
            />
          </div>

          <DialogFooter className="gap-2">
            <Button variant="outline" onClick={handleCancelCreateClient} disabled={creatingClient}>
              Cancelar
            </Button>
            <Button onClick={handleCreateClientFromDropdown} disabled={creatingClient || !newClientName.trim() || newClientName.trim().length < 2} className="bg-gray-900 hover:bg-gray-800">
              {creatingClient ? (<><Loader2 className="mr-2 h-4 w-4 animate-spin" />Creando...</>) : 'Crear'}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Change Status Modal */}
      <Dialog open={changeStatusModalOpen} onOpenChange={setChangeStatusModalOpen}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle>Cambiar estatus</DialogTitle>
            <DialogDescription>
              Selecciona el nuevo estatus para las {selectedIds.size} marca(s) seleccionada(s).
            </DialogDescription>
          </DialogHeader>

          <div className="py-4">
            <Select value={selectedStatusId || "none"} onValueChange={(v) => setSelectedStatusId(v === "none" ? "" : v)}>
              <SelectTrigger>
                <SelectValue placeholder="Seleccionar estatus" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="none">— Sin estatus —</SelectItem>
                {statusCatalog.filter(s => s.is_active !== false).map(status => (
                  <SelectItem key={status.id} value={status.id}>{status.status_name}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <DialogFooter className="gap-2">
            <Button variant="outline" onClick={() => setChangeStatusModalOpen(false)} disabled={bulkActionLoading}>
              Cancelar
            </Button>
            <Button onClick={handleBulkChangeStatus} disabled={bulkActionLoading} data-testid="confirm-change-status">
              {bulkActionLoading ? (<><Loader2 className="mr-2 h-4 w-4 animate-spin" /></>) : null}
              Aplicar
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Bulk Archive Dialog */}
      <AlertDialog open={bulkArchiveDialogOpen} onOpenChange={setBulkArchiveDialogOpen}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>¿Archivar {selectedIds.size} marca(s)?</AlertDialogTitle>
            <AlertDialogDescription>
              Las marcas seleccionadas se ocultarán de la lista principal y se moverán a la papelera.
              Podrás verlas activando el filtro "Ver papelera".
              Esta acción no elimina los datos permanentemente.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel disabled={bulkActionLoading}>Cancelar</AlertDialogCancel>
            <AlertDialogAction
              onClick={handleConfirmArchive}
              disabled={bulkActionLoading}
              className="bg-indigo-600 hover:bg-indigo-700 focus:ring-indigo-600"
            >
              {bulkActionLoading ? (<><Loader2 className="mr-2 h-4 w-4 animate-spin" />Archivando...</>) : 'Archivar'}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      {/* Bulk Delete Dialog - Double Confirmation - ÉPICA 3.4: Textos con buen contraste */}
      <AlertDialog open={bulkDeleteDialogOpen} onOpenChange={(open) => { if (!open) { setDeleteConfirmText(''); setDeleteConfirmCheckbox(false); } setBulkDeleteDialogOpen(open); }}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle className="text-red-600">⚠️ Eliminar {selectedIds.size} marca(s) permanentemente</AlertDialogTitle>
            <AlertDialogDescription className="space-y-4 text-gray-700">
              <p>Esta acción <strong className="text-gray-900">NO SE PUEDE DESHACER</strong>. Se eliminarán todas las marcas seleccionadas junto con:</p>
              <ul className="list-disc pl-5 text-sm text-gray-700">
                <li>Todas las notas</li>
                <li>Todas las alertas</li>
                <li>Todo el historial</li>
                <li>Todos los snapshots</li>
              </ul>

              <div className="space-y-3 pt-4 border-t border-gray-200">
                <div>
                  <Label htmlFor="delete-confirm" className="text-gray-700">Escriba <strong className="text-gray-900">ELIMINAR</strong> para confirmar:</Label>
                  <Input
                    id="delete-confirm"
                    value={deleteConfirmText}
                    onChange={(e) => setDeleteConfirmText(e.target.value)}
                    placeholder="ELIMINAR"
                    className="mt-1"
                    data-testid="delete-confirm-input"
                  />
                </div>
                <div className="flex items-center gap-2">
                  <Checkbox
                    id="delete-checkbox"
                    checked={deleteConfirmCheckbox}
                    onCheckedChange={setDeleteConfirmCheckbox}
                    data-testid="delete-confirm-checkbox"
                  />
                  <Label htmlFor="delete-checkbox" className="text-sm text-gray-700">
                    Entiendo que esta acción es irreversible
                  </Label>
                </div>
              </div>
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel disabled={bulkActionLoading}>Cancelar</AlertDialogCancel>
            <AlertDialogAction
              onClick={handleBulkDelete}
              disabled={bulkActionLoading || deleteConfirmText !== 'ELIMINAR' || !deleteConfirmCheckbox}
              className="bg-red-600 hover:bg-red-700 focus:ring-red-600"
              data-testid="confirm-bulk-delete"
            >
              {bulkActionLoading ? (<><Loader2 className="mr-2 h-4 w-4 animate-spin" />Eliminando...</>) : 'Eliminar permanentemente'}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      {/* Single Delete Dialog - ÉPICA 3.4: Solo ADMIN con doble confirmación */}
      <AlertDialog open={deleteDialogOpen} onOpenChange={(open) => { if (!open) { setDeleteConfirmText(''); setDeleteConfirmCheckbox(false); } setDeleteDialogOpen(open); }}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle className="text-red-600">⚠️ Eliminar marca permanentemente</AlertDialogTitle>
            <AlertDialogDescription className="space-y-4 text-gray-700">
              <p>Esta acción <strong className="text-gray-900">NO SE PUEDE DESHACER</strong>. Se eliminarán todos los datos asociados a la marca
                <span className="font-semibold text-gray-900"> {trademarkToDelete?.denominacion || trademarkToDelete?.expediente}</span>, incluyendo:</p>
              <ul className="list-disc pl-5 text-sm text-gray-700">
                <li>Todas las notas</li>
                <li>Todas las alertas</li>
                <li>Todo el historial</li>
                <li>Todos los snapshots</li>
              </ul>

              <div className="space-y-3 pt-4 border-t border-gray-200">
                <div>
                  <Label htmlFor="single-delete-confirm" className="text-gray-700">Escriba <strong className="text-gray-900">ELIMINAR</strong> para confirmar:</Label>
                  <Input
                    id="single-delete-confirm"
                    value={deleteConfirmText}
                    onChange={(e) => setDeleteConfirmText(e.target.value)}
                    placeholder="ELIMINAR"
                    className="mt-1"
                    data-testid="single-delete-confirm-input"
                  />
                </div>
                <div className="flex items-center gap-2">
                  <Checkbox
                    id="single-delete-checkbox"
                    checked={deleteConfirmCheckbox}
                    onCheckedChange={setDeleteConfirmCheckbox}
                    data-testid="single-delete-confirm-checkbox"
                  />
                  <Label htmlFor="single-delete-checkbox" className="text-sm text-gray-700">
                    Entiendo que esta acción es irreversible
                  </Label>
                </div>
              </div>
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel disabled={deleteLoading}>Cancelar</AlertDialogCancel>
            <AlertDialogAction
              onClick={handleDeleteConfirm}
              disabled={deleteLoading || deleteConfirmText !== 'ELIMINAR' || !deleteConfirmCheckbox}
              className="bg-red-600 hover:bg-red-700 focus:ring-red-600"
            >
              {deleteLoading ? (<><Loader2 className="mr-2 h-4 w-4 animate-spin" />Eliminando...</>) : 'Eliminar permanentemente'}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
      {/* Disambiguation Dialog - ÉPICA 3.4.2 */}
      <Dialog open={disambiguationModalOpen} onOpenChange={setDisambiguationModalOpen}>
        <DialogContent className="max-w-4xl max-h-[80vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Múltiples Resultados Encontrados</DialogTitle>
            <DialogDescription>
              Se encontraron múltiples registros para el expediente <b>{importExpediente}</b>.
              Por favor seleccione el correcto para continuar la ingesta.
            </DialogDescription>
          </DialogHeader>

          <div className="py-4">
            {disambiguationMatches.length > 0 ? (
              <div className="relative overflow-x-auto border rounded-md">
                <table className="w-full text-sm text-left">
                  <thead className="text-xs uppercase bg-muted/50">
                    <tr>
                      <th className="px-4 py-3 font-medium">Expediente</th>
                      <th className="px-4 py-3 font-medium">Registro</th>
                      <th className="px-4 py-3 font-medium">Denominación</th>
                      <th className="px-4 py-3 font-medium">Clase</th>
                      <th className="px-4 py-3 font-medium">Tipo</th>
                      <th className="px-4 py-3 text-right">Acción</th>
                    </tr>
                  </thead>
                  <tbody>
                    {disambiguationMatches.map((match) => (
                      <tr key={match.index} className="border-b hover:bg-muted/50 transition-colors">
                        <td className="px-4 py-3 font-medium">{match.expediente}</td>
                        <td className="px-4 py-3 text-muted-foreground">{match.registro}</td>
                        <td className="px-4 py-3 font-medium">{match.denominacion}</td>
                        <td className="px-4 py-3 text-muted-foreground">{match.clase}</td>
                        <td className="px-4 py-3 text-muted-foreground">{match.tipo_solicitud_label || 'N/A'}</td>
                        <td className="px-4 py-3 text-right">
                          <Button
                            size="sm"
                            variant="default"
                            onClick={() => handleDisambiguationSelect(match)}
                            disabled={importLoading}
                          >
                            {importLoading && selectedMatch?.index === match.index ? (
                              <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                            ) : null}
                            Seleccionar
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="text-center py-8 text-muted-foreground">
                <Loader2 className="h-8 w-8 animate-spin mx-auto mb-2" />
                <p>Cargando opciones...</p>
              </div>
            )}
          </div>

          <DialogFooter>
            <Button variant="outline" onClick={() => setDisambiguationModalOpen(false)}>Cancelar</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>


      {/* Sync Preview Modal */}
      < SyncPreviewModal
        isOpen={syncModalOpen}
        onClose={setSyncModalOpen}
        previewData={syncPreviewData}
        onApply={handleApplySync}
        title="Sincronización - Revisar Cambios"
        confirmLabel={applyingSync ? "Aplicando..." : "Confirmar Cambios"}
      />
      {/* Modal Selección Columnas PDF */}
      <Dialog open={exportPDFModalOpen} onOpenChange={setExportPDFModalOpen}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle>Exportar a PDF</DialogTitle>
            <DialogDescription>
              Selecciona las columnas que deseas incluir en el reporte.
            </DialogDescription>
          </DialogHeader>
          <div className="grid grid-cols-2 gap-4 py-4">
            {Object.entries({
              img: "Imagen",
              expediente: "Expediente",
              registro: "Registro",
              denominacion: "Denominación",
              tipo: "Tipo",
              clases: "Clases",
              cliente: "Cliente",
              estatus: "Estatus",
              fecha_presentacion: "Fecha Pres.",
              fecha_vigencia: "Fecha Vig.",
              notas: "Notas"
            }).map(([key, label]) => (
              <div key={key} className="flex items-center space-x-2">
                <Checkbox
                  id={`col-${key}`}
                  checked={pdfColumns[key]}
                  onCheckedChange={() => handleTogglePdfColumn(key)}
                />
                <label htmlFor={`col-${key}`} className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
                  {label}
                </label>
              </div>
            ))}
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setExportPDFModalOpen(false)}>Cancelar</Button>
            <Button onClick={() => {
              const selected = Object.keys(pdfColumns).filter(k => pdfColumns[k]);
              handleExport('pdf', { columns: selected });
              setExportPDFModalOpen(false);
            }}>
              Exportar
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
      {/* Bulk Import Modal - Nueva versión con backend queue */}
      <BulkImportModal
        isOpen={bulkImportModalOpen}
        onClose={() => setBulkImportModalOpen(false)}
        onImportComplete={() => fetchData()}
      />
    </>
  );
};
